module.exports = __webpack_public_path__ + "static/img/9-01.2bf17b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9-01.png
// module id = 183
// module chunks = 1